/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u20m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taking a 20-minute power nap without sliding into deep sleep.`)
};

const es_timer_u20m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomar una siesta corta de 20 minutos sin caer en sueño profundo.`)
};

const de_timer_u20m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen 20-Minuten-Powernap machen, ohne in den Tiefschlaf abzugleiten.`)
};

const nl_timer_u20m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een powernap van 20 minuten doen zonder in diepe slaap weg te zakken.`)
};

const fr_timer_u20m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faire une sieste éclair de 20 minutes sans basculer dans le sommeil profond.`)
};

const it_timer_u20m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fare un power nap di 20 minuti senza scivolare nel sonno profondo.`)
};

const pt_br2_timer_u20m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirar um cochilo rápido de 20 minutos sem cair em sono profundo.`)
};

const pt_timer_u20m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer uma soneca rápida de 20 minutos sem entrar em sono profundo.`)
};

const ja_timer_u20m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`深い眠りに入り込まないよう、20分間のパワーナップを取る。`)
};

const zh_timer_u20m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进行20分钟小睡，避免陷入深度睡眠。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u20m_use2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u20m_use2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u20m_use2", locale)
	if (locale === "en") return en_timer_u20m_use2(inputs)
	if (locale === "es") return es_timer_u20m_use2(inputs)
	if (locale === "de") return de_timer_u20m_use2(inputs)
	if (locale === "nl") return nl_timer_u20m_use2(inputs)
	if (locale === "fr") return fr_timer_u20m_use2(inputs)
	if (locale === "it") return it_timer_u20m_use2(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u20m_use2(inputs)
	if (locale === "pt") return pt_timer_u20m_use2(inputs)
	if (locale === "ja") return ja_timer_u20m_use2(inputs)
	return zh_timer_u20m_use2(inputs)
};